// extracted by mini-css-extract-plugin
module.exports = {"item":"TerminalAdd_item__11VeB","image":"TerminalAdd_image__3Z5Bm","title":"TerminalAdd_title__2e4R4","description":"TerminalAdd_description__CFytV"};